import { initializeNeuroGuide, logger } from '@ignitesales/neuro-application';
import ThemeAppComponent from "../../../../../_themes/first-commonwealth-theme/src/shared/js/AppBase.jsx";
import LoadingAppComponent from '../../../../../_themes/first-commonwealth-theme/src/shared/js/AppLoading.jsx';
import messages from '../i18n/messages.mjs';
import loadFonts from '../../../../../_themes/first-commonwealth-theme/src/shared/js/utils/loadFonts.mjs';
import loginReducer from "../../../../../_themes/first-commonwealth-theme/src/shared/js/reducers/loginReducer.mjs";
import productsReducer from "../../../../../_themes/first-commonwealth-theme/src/shared/js/reducers/productsReducer.mjs";
import customMessages from "../i18n/custom";

const init = async () => {
  loadFonts();
  await initializeNeuroGuide ({
    AppComponent: ThemeAppComponent,
    AppLoadingComponent: LoadingAppComponent,
    messages: messages,
    reducers: [ loginReducer, productsReducer ],
    guideConfig: {
      customMessages
    }
  });
  logger.info('Go for takeoff!');
};
init();